import React, { ComponentProps } from 'react';

import {
  DesktopNavbar,
  MobileNavbar,
} from 'shared/presentation/components/organisms';
import { useLocale } from 'shared/presentation/contexts';
import { useMediaQuery } from 'shared/presentation/hooks';

interface IAppNavbarProps {
  mobileVariant?: ComponentProps<typeof MobileNavbar>['variant'];
}

const AppNavbar: React.FC<IAppNavbarProps> = ({ mobileVariant }) => {
  const isMobile = useMediaQuery('md');
  const { language } = useLocale();

  const shouldShowNavbar = language === 'pt';

  if (!shouldShowNavbar) return null;

  if (isMobile) return <MobileNavbar variant={mobileVariant} />;

  return <DesktopNavbar />;
};

export default AppNavbar;
